import { Box, Group } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './StickyActionBar.module.css';

interface StickyActionBarProps {
  leftActions?: ReactNode;
  rightActions?: ReactNode;
  topContent?: ReactNode;
}

export function StickyActionBar({ leftActions, rightActions, topContent }: StickyActionBarProps) {
  return (
    <>
      <div className={classes.spacer} aria-hidden />
      <Box className={classes.bar}>
        {topContent}
        <Group justify="space-between">
          <Group gap="sm">{leftActions}</Group>
          <Group gap="sm">{rightActions}</Group>
        </Group>
      </Box>
    </>
  );
}
